import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import styles from './TableList.module.scss';
import { XPagination } from '@/components/xqxc_ui';
import { TableActionType as ta } from '@/util/enum';
import { tooltipStyle, tooltip, cellWidth, priceFenToYuanCell } from '@/components/TableCell';
import moment from 'moment';

function TableList(props) {

    const renderStatus = (key, item)=>{
        let ops = {'INIT': '新建', 'DOWN': '已收款'};
        return ops[item.status];
    };

    const renderBizType = (key)=>{
        return props.bizEnum[key];
    };

    const _renderActionCell = (key, item) => {
        const { tableAction } = props;
        return (
            <div className={styles.action}>
                <div className={styles.item} onClick={() => tableAction('detail', item)}>详情</div>
                {item.status === 'INIT' && <div className={styles.item} onClick={() => tableAction('edit', item)}>编辑</div>}
                {item.status === 'INIT' && <div className={styles.item} onClick={() => tableAction('confirm', item)}>确认收款</div>}
            </div>
        );
    };

    const renderData = (key, item)=>{
        return moment(item.receiveDate).format('YYYY/MM/DD');
    };

    const columns = [
        {
            title: '收款单号',
            dataIndex: 'id',
            key: 'id',
            width: '200px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '企业名称',
            dataIndex: 'payCompanyName',
            key: 'payCompanyName',
            width: cellWidth.big,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '交款总额（元）',
            dataIndex: 'payTotalAmount',
            key: 'payTotalAmount',
            width: '150px',
            align: 'center',
            render: priceFenToYuanCell
        },
        {
            title: '状态',
            dataIndex: 'status',
            key: 'status',
            width: '100px',
            align: 'center',
            onCell: tooltipStyle,
            render: renderStatus
        },
        {
            title: '业务类型',
            dataIndex: 'businessType',
            key: 'businessType',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: renderBizType
        },
        {
            title: '收款日期',
            dataIndex: 'receiveDate',
            key: 'receiveDate',
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: renderData
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'id',
            width: '200px',
            align: 'center',
            fixed: 'right',
            render: (text, item) => _renderActionCell(item.id, item)
        }
    ];

    return (
        <div className={styles.tableContainer}>
            <Table
                rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                rowKey={r=>r.id}
                columns={columns}
                dataSource={props.renderData.dataList || []}
                pagination={false}
                scroll={{ y: true }}
            />
            <XPagination
                resultTotal={props.renderData.resultTotal}
                pageSize={props.renderData.pageSize}
                pageNum={props.renderData.pageNum}
                onChange={props.paginationChange}
            />
        </div>
    );
}

TableList.propTypes = {
    renderData: PropTypes.object.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
    bizEnum: PropTypes.object.isRequired,  // 业务类型枚举对象
};

export default TableList;